import { RcClasses } from '../../../../foundation';
export var RcTabListClasses = RcClasses([], 'RcTabList');
